import { frequencyToMonthly } from "./formUtils";

const cleanCurrency = (val) =>
  parseFloat(String(val || "").replace(/[^0-9.]/g, "")) || 0;

function calculatePreQualification(formDataPurchase) {
  const result = {
    eligibleProducts: [],
    grantEligible: false,
    messages: [],
    pricing: { FHA: null, USDA: null, VA: null },
    details: {},
  };

  // 1. --- Disqualification checks as before ---
  const isClientDisqualified =
    (formDataPurchase.workExperienceDuration === "<2" &&
      formDataPurchase.studentStatus !== "Yes" &&
      formDataPurchase.employmentType !== "Retired") ||
    (formDataPurchase.stateTaxesFiled === "No" &&
      formDataPurchase.studentStatus !== "Yes" &&
      formDataPurchase.employmentType !== "Retired");

  const isSpouseDisqualified =
    formDataPurchase.prenuptialAgreement !== "Yes" &&
    formDataPurchase.maritalStatus === "Married" &&
    (
      (formDataPurchase.spouseWorkExperienceDuration === "<2" &&
        formDataPurchase.spouseEmploymentType !== "Retired") ||
      (formDataPurchase.spouseStateTaxesFiled === "No" &&
        formDataPurchase.spouseEmploymentType !== "Retired")
    );

  const shouldExcludeIncome = isClientDisqualified && isSpouseDisqualified;

  // 2. --- Additional income extraction ---
  const rawAdditionalWorkIncome = cleanCurrency(formDataPurchase.additionalWorkIncome);
  const additionalWorkIncomeFreq = formDataPurchase.additionalWorkIncomeFrequency;
  const additionalWorkHoursPerWeek = cleanCurrency(formDataPurchase.additionalWorkHoursPerWeek);

  const rawBonusIncome = cleanCurrency(formDataPurchase.bonusIncome);
  const bonusIncomeFreq = formDataPurchase.bonusIncomeFrequency;

  const rawSpouseAdditionalWorkIncome = cleanCurrency(formDataPurchase.spouseAdditionalWorkIncome);
  const spouseAdditionalWorkIncomeFreq = formDataPurchase.spouseAdditionalWorkIncomeFrequency;
  const spouseAdditionalWorkHoursPerWeek = cleanCurrency(formDataPurchase.spouseAdditionalWorkHoursPerWeek);

  const rawSpouseBonusIncome = cleanCurrency(formDataPurchase.spouseBonusIncome);
  const spouseBonusIncomeFreq = formDataPurchase.spouseBonusIncomeFrequency;

  // 3. --- Convert to monthly ---
  const clientAdditionalWorkMonthly = (!isClientDisqualified)
    ? frequencyToMonthly(rawAdditionalWorkIncome, additionalWorkIncomeFreq, additionalWorkHoursPerWeek)
    : 0;
  const clientBonusMonthly = (!isClientDisqualified)
    ? frequencyToMonthly(rawBonusIncome, bonusIncomeFreq)
    : 0;

  const spouseAdditionalWorkMonthly = (!isSpouseDisqualified)
    ? frequencyToMonthly(rawSpouseAdditionalWorkIncome, spouseAdditionalWorkIncomeFreq, spouseAdditionalWorkHoursPerWeek)
    : 0;
  const spouseBonusMonthly = (!isSpouseDisqualified)
    ? frequencyToMonthly(rawSpouseBonusIncome, spouseBonusIncomeFreq)
    : 0;

 
  if (shouldExcludeIncome) {
    result.messages.push(
      "Given that you selected source of income from self-employment or Hired as a contractor, or less than 2 years of experience without qualifying education, you will be contacted by an officer."
    );
    result.pricing = { FHA: 0, USDA: 0, VA: 0 };
    return result;
  }

  if (formDataPurchase.bankruptcyOrForeclosure === "Yes") {
    result.messages.push(
      "Due to your selected bankruptcy or foreclosure history, you will be contacted by an officer. No prequalification can be issued at this time."
    );
    result.pricing = { FHA: 0, USDA: 0, VA: 0 };
    return result;
  }

  if (
    formDataPurchase.stateTaxesFiled === "No" &&
    formDataPurchase.employmentType !== "Retired"
  ) {
    result.messages.push(
      "You indicated that state tax returns were not filed for the last two years. An officer must review your file before prequalification can proceed."
    );
    result.pricing = { FHA: 0, USDA: 0, VA: 0 };
    return result;
  }

  if (
    formDataPurchase.employmentType !== "Retired" &&
    formDataPurchase.workExperienceDuration === "<2" &&
    formDataPurchase.occupation2Years === "No" &&
    formDataPurchase.studentStatus !== "Yes"
  ) {
    result.messages.push(
      "Based on less than two years in your current occupation and no qualifying education history, your information must be reviewed by an officer."
    );
    result.pricing = { FHA: 0, USDA: 0, VA: 0 };
    return result;
  }

  // --- Calculation setup ---
 
  const rawIncome = cleanCurrency(formDataPurchase.income);
  const rawSpouseIncome = cleanCurrency(formDataPurchase.spouseIncome);

  const income =
  (!isClientDisqualified ? rawIncome : 0) +
  (!isSpouseDisqualified ? rawSpouseIncome : 0) +
  clientAdditionalWorkMonthly +
  clientBonusMonthly +
  spouseAdditionalWorkMonthly +
  spouseBonusMonthly;
  const monthlyIncome = income;
  const monthlyDebts = cleanCurrency(formDataPurchase.totalDebts || 0);

  // --- FHA county limits ---
  const fhaLimits = {
    CULEBRA: 532450,
    defaultLow: 524225,
    defaultHigh: 690000,
  };
  const normalize = (str) => str.normalize("NFD").replace(/[̀-ͯ]/g, "");
  const location = normalize(
    (formDataPurchase.location || "").trim().toUpperCase()
  );
  let fhaMaxLoanAmount = fhaLimits.defaultLow;
  const highLimitCounties = [
    "AGUAS BUENAS",
    "AIBONITO",
    "BARCELONETA",
    "BARRANQUITAS",
    "BAYAMON",
    "CAGUAS",
    "CANOVANAS",
    "CAROLINA",
    "CATANO",
    "CAYEY",
    "CEIBA",
    "CIALES",
    "CIDRA",
    "COMERIO",
    "COROZAL",
    "DORADO",
    "FAJARDO",
    "FLORIDA",
    "GUAYNABO",
    "GURABO",
    "HUMACAO",
    "JUNCOS",
    "LAS PIEDRAS",
    "LOIZA",
    "LUQUILLO",
    "MANATI",
    "MAUNABO",
    "MOROVIS",
    "NAGUABO",
    "NARANJITO",
    "OROCOVIS",
    "RIO GRANDE",
    "SAN JUAN",
    "SAN LORENZO",
    "TOA ALTA",
    "TOA BAJA",
    "TRUJILLO ALTO",
    "UTUADO",
    "VEGA ALTA",
    "VEGA BAJA",
    "YABUCOA",
  ];
  if (location === "CULEBRA") {
    fhaMaxLoanAmount = fhaLimits["CULEBRA"];
  } else if (highLimitCounties.includes(location)) {
    fhaMaxLoanAmount = fhaLimits.defaultHigh;
  }

  // --- VA/USDA logic (as before) ---
  const isVeteran = formDataPurchase.veteranStatus === "Yes";
  if (isVeteran) {
    result.eligibleProducts.push("VA");
  } else {
    result.messages.push(
      "Client is not a veteran. VA loan will not be considered."
    );
  }

  const disqualifiedUSDACounties = [
    "Mayaguez",
    "Aguadilla",
    "Ponce",
    "Arecibo",
    "Caguas",
    "Dorado",
    "Toa Baja",
    "Toa Alta",
    "Bayamon",
    "Guaynabo",
    "San Juan",
    "Trujillo Alto",
    "Carolina",
  ];
  const isCountyUSDAEligible = !disqualifiedUSDACounties.includes(
    normalize(formDataPurchase.location)
  );
  const isIncomeUSDAEligible = income <= 112450;
  if (isCountyUSDAEligible && isIncomeUSDAEligible) {
    result.eligibleProducts.push("USDA");
  } else {
    result.messages.push(
      "Client is not eligible for USDA based on income or location."
    );
  }

  // Always include FHA
  result.eligibleProducts.push("FHA");

  // --- Grant logic (always apply full $35k as down when eligible) ---
  const grantLimits = { unmarried: 4504.16, married: 5145.83 };
  const maritalStatus = (formDataPurchase.maritalStatus || "").toLowerCase();
  const grantIncomeLimit =
    maritalStatus === "married" ? grantLimits.married : grantLimits.unmarried;
  const grantIsEligible = income <= grantIncomeLimit;

  function calculateMaxLoanAndSalesPrice(product, monthlyIncome, monthlyDebts) {
    let frontRatio = 0,
      backRatio = 0,
      ltv = 1,
      upfrontMI = 0,
      monthlyMIrate = 0;

    if (product === "FHA" || product === "VA") {
      frontRatio = 0.365;
      backRatio = 0.465;
    } else if (product === "USDA") {
      frontRatio = 0.31;
      backRatio = 0.42;
    }

    if (product === "FHA") {
      ltv = 0.965;
      upfrontMI = 0.0175;
      monthlyMIrate = 0.005;
    } else if (product === "USDA") {
      ltv = 1.0;
      upfrontMI = 0.01;
      monthlyMIrate = 0.0035;
    } else if (product === "VA") {
      ltv = 1.0;
      upfrontMI = 0.033;
      monthlyMIrate = 0; // VA has no monthly MI
    }

    const creditScore =
      parseInt(String(formDataPurchase.creditScore || "").replace(/\D/g, "")) ||
      0;
    const interestRate = creditScore >= 740 ? 0.0625 : 0.065;

    const back = monthlyIncome * backRatio - monthlyDebts;
    const maxHousing = Math.min(monthlyIncome * frontRatio, back);

    if (!maxHousing || maxHousing <= 0) return 0;

    let low = 35000;
    let high = 1000000;
    let closestPrice = 0;
    let bestDetails = {};

    if (product === "FHA" && grantIsEligible) {
      while (high - low > 1) {
        const mid = (low + high) / 2;
        const grantApplied = 35000;
        const baseLoan = mid - grantApplied;
        if (baseLoan > fhaMaxLoanAmount) {
          high = mid;
          continue;
        }
        const financedUpfront = baseLoan * upfrontMI;
        const totalLoan = baseLoan + financedUpfront;
        const monthlyPI =
          (totalLoan * interestRate) /
          12 /
          (1 - Math.pow(1 + interestRate / 12, -360));
        const hazard = (totalLoan * 0.00298) / 12;
        const mi = (totalLoan * monthlyMIrate) / 12;
        const totalPITI = monthlyPI + hazard + mi;
        const front = totalPITI / monthlyIncome;
        const back = (totalPITI + monthlyDebts) / monthlyIncome;

        if (
          totalPITI <= maxHousing &&
          baseLoan <= fhaMaxLoanAmount &&
          front <= frontRatio &&
          back <= backRatio
        ) {
          closestPrice = mid;
          low = mid;
          bestDetails = {
            salesPrice: Math.round(mid),
            grantApplied,
            clientDown: 0,
            baseLoan: Math.round(baseLoan),
            upFrontMI: Math.round(financedUpfront * 100) / 100,
            totalLoan: Math.round(totalLoan * 100) / 100,
            monthlyPI: Math.round(monthlyPI * 100) / 100,
            mi: Math.round(mi * 100) / 100,
            hazard: Math.round(hazard * 100) / 100,
            totalPITI: Math.round(totalPITI * 100) / 100,
            ratios: {
              front: +(front * 100).toFixed(2),
              back: +(back * 100).toFixed(2),
            },
          };
        } else {
          high = mid;
        }
      }
      // Attach bestDetails for display/PDFs
      result.details = bestDetails;
      return Math.round(closestPrice);
    } else {
      // VA/USDA/regular FHA logic
      while (high - low > 1) {
        const mid = (low + high) / 2;
        const baseLoan = ltv * mid;
        const financedUpfront = baseLoan * upfrontMI;
        const totalLoan = baseLoan + financedUpfront;
        const monthlyPI =
          (totalLoan * interestRate) /
          12 /
          (1 - Math.pow(1 + interestRate / 12, -360));
        const hazard = (mid * 0.00298) / 12;
        const mi = (totalLoan * monthlyMIrate) / 12;
        const totalPITI = monthlyPI + hazard + mi;

        if (totalPITI <= maxHousing) {
          closestPrice = mid;
          low = mid;
        } else {
          high = mid;
        }
      }
      return Math.round(closestPrice);
    }
  }

  for (const product of result.eligibleProducts) {
    const maxSalesPrice = calculateMaxLoanAndSalesPrice(
      product,
      monthlyIncome,
      monthlyDebts
    );
    const normalized = product.toUpperCase();
    if (normalized === "FHA") {
      result.pricing.FHA = Math.min(maxSalesPrice, fhaMaxLoanAmount);
    } else {
      result.pricing[normalized] = maxSalesPrice;
    }
  }

  // Output
  result.grantEligible = grantIsEligible;
  result.monthlyIncome = monthlyIncome;
  result.totalDebts = monthlyDebts;
  result.frontEndRatio = result.eligibleProducts.includes("FHA")
    ? 0.37
    : result.eligibleProducts.includes("VA")
    ? 0.37
    : result.eligibleProducts.includes("USDA")
    ? 0.31
    : 0;
  result.backEndRatio = result.eligibleProducts.includes("FHA")
    ? 0.47
    : result.eligibleProducts.includes("VA")
    ? 0.47
    : result.eligibleProducts.includes("USDA")
    ? 0.42
    : 0;

  return result;
}

export default calculatePreQualification;
